document.addEventListener('DOMContentLoaded', function(){
    const selectEl = document.querySelector('[data-custom-select]');
    const chatToggle = document.querySelector('[data-toggle-chat]');
    selectEl.addEventListener("change", function(event){
        if( this.value.includes('Product Information') )
            window.angularComponentRef.component.optimyScreenCallFromOutside('joinqueue');
    });

    if( chatToggle )
        chatToggle.addEventListener("click", function(event){
            window.angularComponentRef.component.optimyScreenCallFromOutside('joinqueue');
        });
});